import { findAllCities, findAllCitiesByDepartment } from '../../_services/city.service';

export const findAllCitiesEvent= async () => {
    let res = await findAllCities();
    if(! res.ok){
        throw new Error(res.error);
    }
    return res;
}

export const findAllCitiesByDepartmentEvent= async (department) => {
    let res = await findAllCitiesByDepartment(department);
    if(! res.ok){
        throw new Error(res.error);
    }
    return res;
}